<template>
    <div class="group">
         <div class="banner">
             <img src="../../static/img/banners@2x.png" alt="">
         </div>
         <!-- 集团概况内容列表 -->
          <ul :class="{ active_nav : nav }" class="groupList ">
                <li v-for=" (item, i) in jtNav" :key="i" @click="$router.push({ path: item.path }),active = i" :class="{ active1: active === i }"> {{item.navli}} </li>
            </ul>
         <div class="group_cont">
            <!-- 飞猪介绍 -->
             <div class="fzjs cent" id="jianjie">
                 <div class="fzjs_title">
                     <h4>飞猪科技</h4>
                     <p>ABOUT FEIZHU</p>
                 </div>
                 <p class="txt">北京飞猪科技有限公司是一家通过自主研发SaaS系统，为保险公司提供综合技术服务的金融科技企业，旗下全资控股协和万邦和方胜磐石保两家全国性保险经纪公司，产寿险年保费收入近100亿元。</p>
             </div>
             <!-- 飞猪优势 -->
             <div class="fzys">
                 <div class="fzys_title" id="ys">
                     <h4>飞猪优势</h4>
                     <p>ABOUT ADVANTAGE</p>
                 </div>
                 <ul class="ys_cont">
                     <li><img src="../../static/img/专业团队@2x.png" alt=""></li>
                     <li class="ys_cent">
                         <div class="ys_center left">
                             <h4>专业团队</h4>
                             <h5>Professional team</h5>
                             <div>
                                 <p>我们有着</p>
                                 <p>敏锐的洞察力、</p>
                                 <p>超强的沟通能力、</p>
                                 <p>出色的团队协作才能、</p>
                                 <p>勤奋顽强的精神</p>
                             </div>
                         </div>
                     </li>
                     <li class="ys_cent">
                         <div class="ys_center">
                             <h4>资源丰富</h4>
                             <h5>Rich resources</h5>
                             <div>
                                 <p>我们是一条链的发展中</p>
                                 <p>的公司</p>
                                 <p>有着多个强大的股东</p>
                                 <p>多个知名合作公司</p>
                                 <p>以及发展中的相关行业链</p>
                             </div>
                         </div>
                     </li>
                     <li><img src="../../static/img/资源丰富@2x.png" alt=""></li>
                     <li><img src="../../static/img/最新技术@2x.png" alt=""></li>
                     <li class="ys_cent">
                         <div class="ys_center  left">
                             <h4>最新技术</h4>
                             <h5> Latest technology</h5>
                             <div>
                                 <p>我们有着</p>
                                 <p>不同的硬件</p>
                                 <p>能够更好地提供功能</p>
                                 <p>显著提升性能</p>
                                 <p>并具有更高可靠性能</p>
                             </div>
                         </div>
                     </li>
                     <li class="ys_cent">
                         <div class="ys_center">
                             <h4>核心服务</h4>
                             <h5>Core services</h5>
                             <div>
                                 <p>满足需求是我们不断强化的</p>
                                 <p>为提供满足一个或多个</p>
                                 <p>客户的期望</p>
                                 <p>我们一直在为之而努力前进</p>
                                 <p>只为了更好地满足客户需求</p>
                             </div>
                         </div>
                     </li>
                     <li><img src="../../static/img/核心服务@2x.png" alt=""></li>
                 </ul>
             </div>
             <!-- 发展历程 -->
             <div class="fzlc" id="fzlc">
                 <img style="width:100%;height:100%;" src="../../static/img/发展历史背景@2x.png" alt="">
                 <div class="fzlc_title">
                    <h4>发展历程</h4>
                    <p>ABOUT DEVELOPMENT</p>
                    <!-- 发展时间 -->
                  <ul class="fzlc_cont">
                          <swiper :options="swiperOption" ref="mySwiper">
                                <swiper-slide>
                                    <h4 ref="month">2018.11</h4>
                                        <p>北京飞猪科技正式与太平保险公司合作，迎来又一个更大的改变</p>
                                </swiper-slide>
                                <swiper-slide>
                                    <h4 ref="month">2018.08</h4>
                                    <p>北京飞猪科技正式与协诚保险公司合作，协保宝APP诞生</p>
                                </swiper-slide>
                                <swiper-slide> 
                                    <h4 ref="month">2018.07</h4>
                                    <p>北京飞猪科技与鼎和保险公司合作，鼎龙宝APP诞生</p></swiper-slide>
                                <swiper-slide>   
                                    <h4 ref="month">2018.05</h4>
                                    <p>北京飞猪科技与太平保险公司合作，太慧宝APP诞生</p></swiper-slide>
                                <swiper-slide> 
                                    <h4 ref="month">2018.01</h4>
                                        <p>北京飞猪科技年收入与去年相比成交率在不断增长</p>
                                </swiper-slide>
                                <swiper-slide> 
                                    <h4 ref="month">2017.06</h4>
                                        <p>北京飞猪科技正式与紫金保险公司合作，推出紫尊保APP</p>
                                </swiper-slide>
                                <swiper-slide> 
                                    <h4 ref="month">2016.07</h4>
                                        <p>推出联合保APP、热保APP</p>
                                </swiper-slide>
                                <swiper-slide> 
                                    <h4 ref="month">2015.03</h4>
                                        <p>北京飞猪科技有限公司成立</p>
                                </swiper-slide>
                                
                                <div class="swiper-button-prev" slot="button-prev" style="top: 95%"></div>
                                <div class="swiper-button-next" slot="button-next" style="top: 95%"></div>
                         </swiper>
                  </ul>
                 </div>
                <ul class="lcTime">
                    <li ref="li"></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
                <div class="shuxian">
                    <span class="xian"></span>
                    <span class="yuan"></span>

                </div>
             </div>
             <div class="fzgd" id="gd">
                  <div class="fzgd_title">
                     <h4>股东介绍</h4>
                     <p> SHAREHOLDER INTRODUCTION</p>
                 </div>
                 <!-- FESCO -->
                 <div class="fzgd_list" id="fescoAdd">
                     <img src="../../static/img/FESCO背景@2x.png" alt="">
                     <div class="listCont">
                        <h4>FESCO</h4>
                        <P>北京外企人力资源服务有限公司（FESCO）成立于1979年，是开创中国人力资源服务行业的第一家企业，在业界最具竞争力和品牌价值，荣膺中国500强企业。</P>
                        <p>FESCO拥有专业化的人力资源服务体系、丰富的市场经验以及完备的业务资质，是国内首家为外商驻华代表机构、外商金融机构、经济组织提供专业化人力资源服务的公司。</p>
                        <p>FESCO人力资源服务体系依托网站、呼叫中心等技术手段，涵盖招聘、劳务派遣、员工福利外包、IT人员外包、财务外包、外籍人员服务等多重领域，在全国建立了190余家投资公司及分公司，服务于近3万家中外企业客户，近200万国际化人才，覆盖全国31个省市自治区400余座城市的服务网络，通过“一地签约，全国服务”为客户提供最大便捷。客户包括众多国际知名跨国企业、外资企业、国营企业、民营企业，横跨通讯、电子、IT、汽车、石化、医药、金融、快速消费品等多个行业。FESCO通过搭建以先进IT技术为基础，专业服务团队为核心，有效整合、管理各类资源的共享服务平台，提供全方位人力资源解决方案，成为客户坚实的合作伙伴。</p>

                     </div>
                 </div>
                 <!-- 联合医务 -->
                 <div class="fzgd_list" id="lhywAdd">
                     <img src="../../static/img/联合医务背景@2x.png" alt="">
                     <div class="listCont">
                          <h4>联合医务</h4>
                        <P>香港周大福旗下企业，香港主板上市公司（HK00722）联合医务集团有限公司 (UMP) 由多位资深医生管理，并由专业医护团队参与日常运营，致力于通过旗下诊所网络为不同社区提供多元化的医疗保健服务</P>
                        <p>除了服务广大市民外，同时为香港、澳门及中国内地各类企业与机构提供医疗保健计划。 自九十年代后期，诊所网络已从香港扩展至澳门，近年于北京、上海、广州、深圳设立了医疗中心。</p>
                        <p>目前已服务超过3,000家企业，累积逾1,000,000名会员。联合医务于香港、澳门及中国大陆设有600多个网络服务点，其中超过40个为自设的医疗中心。</p>

                     </div>
                 </div>
                 <!-- 台湾磐石 -->
                 <div class="fzgd_list" id="fsAdd">
                     <img src="../../static/img/台湾磐石背景@2x.png" alt="">
                     <div class="listCont">
                         <h4>台湾磐石</h4>
                        <P>磐石金控集团从2003年成立以来，以六个阶段的成长计划，展开全球化布局战略，两岸实力雄厚的战略伙伴及股东群不断投入丰富的在地资源。</P>
                        <p>在专业上，磐石保经破业界纪录，9次蝉联保险业奥斯卡奖之称的保险信望爱「最佳保险专业奖」，赢得业界一致肯定。经过多年努力，</p>
                        <p>在两岸三地搭起一个华人理财平台，让专业人才以IFA（独立财务顾问）型态在平台上，为有理财需求的客户提供高品质服务。</p>

                     </div>
                 </div>
             </div>

         </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
        flag: '',
          active: 0,
          nav: false,
            swiperOption: {
            notNextTick: true,
            // autoplay: true,
            loop : false,
            direction : 'horizontal',
            grabCursor : true,
            setWrapperSize :true,
            autoHeight: true,
            pagination : '.swiper-pagination',
            paginationClickable :true,
            prevButton:'.swiper-button-prev',//上一张
            nextButton:'.swiper-button-next',//下一张
            // scrollbar:'.swiper-scrollbar',//滚动条
            mousewheelControl : true,
            observeParents:true,
            debugger: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                disabledClass: 'my-button-disabled',
            },
 
        },
         jtNav: [
        {
          navli: '简介',
          path: '/group?#jianjie'
        },
        {
          navli: '优势',
          path: '/group#ys'
        },
        {
          navli: '发展历程',
          path: '/group#fzlc'
        },
        {
          navli: '股东介绍',
          path: '/group#gd'
        }
      ]
    }
    //   popupVisible: false
    },
    mounted() {

        this.isMobile()        
    },
  methods: {
    right () {    
    //   console.log(this.$refs.month.innerHTML)
    },
     isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        // if()
        if(flag){
        //    alert("mobile") 
            this.$router.push({ path: "/group" });
        }else{
             this.$router.push({ path: "/jtgk?page=1" });
        }
        // return flag;
    }
  },
  watch: {

  },
}

</script>

<style lang="scss" scoped>
.swiper-pagination {
    position: relative;
}
.swiper-container {
    height: 4.55rem;
    // background-color: pink;
    //  cursor: pointer;
}
.swiper-button-next{
    width: .5rem;
    height: .4rem;
    right: .5rem;

}
.swiper-button-prev{
    width: .5rem;
    height: .4rem;
    left: .5rem;
}
.swiper-slide{
     width: 3.2rem;
}
.cent{
  margin: 0 auto;
  width: 92%;
  }
.banner{
    height: 3.4rem;
    img{
        width: 100%;
        height: 100%;
    }
}
.groupList{
    color: #8f9194;
    font-size: .3rem;
    height: 1.15rem;
    line-height: 1.15rem;
    display: flex;
    justify-content:space-between;
    border-bottom: .1rem solid #fbfbf7;
    padding: .3rem;
    li{
        width: 1.4rem;
        height: .6rem;
        line-height: .6rem;
        text-align: center;
    }
}
.active1 {
        color: red;
    }
.group_cont{
    .fzjs,.fzys,.fzlc,.fzgd{
           font-size: .28rem;
           color: #676e74;
        .fzjs_title,.fzys_title,.fzlc_title,.fzgd_title{
            padding: .2rem 0;
            text-align: center;
            h4{
                color: #0250a4;
                font-weight: 600;
                line-height: .42rem;
                font-size: .3rem;
            }
            p{
                font-size: .22rem;
                color: #848a90;

            }
        }
        .fzlc_title{
            .fzlc_cont{
                h4{
                    color: #df0f1d;
                    line-height: .6rem;
                    font-size: .26rem;
                }
                p{
                    font-size: .26rem;
                    font-weight: 600;
                    text-align: left;
                    width: 2.9rem;
                    color: #df0f1d;
                }

            }

        }
        .txt{
             padding: .2rem 0;
            text-indent: 2em;

        }
        .ys_cont{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            background-color: #e3f0fd;
            li{
                img{
                    display: block;
                    width: 4rem;
                    height: 3rem;
                }
                .ys_center{
                    text-align: right;
                    font-size: .22rem;
                    h4{
                        font-size: .26rem;
                        color: #ea0e23;
                        line-height: .38rem;
                        padding-top: 0.33rem;
                    }
                    h5{
                        font-size: .16rem;
                        color: #818f9b;
                        line-height: .3rem;
                    }
                }
                .left{
                     text-align: left;
                }
            }
            .ys_cent{
                margin: 0 auto;
            }
        }

    }
    .fzlc{
        position: relative;
        .fzlc_title{
            width: 4.7rem;
            height: 4.7rem;
            border: 2px solid #024e9f;
            border-radius: 50%;
            position: absolute;
            top: .5rem;
            left: 50%;
            transform: translateX(-50%);
            .fzlc_cont{
                width: 2.9rem;
                margin: 0 auto;
                padding-top: .9rem;
                position: relative;
                li{
                    position: absolute;
                    top: .9rem;
                    p,h4{
                    font-size: .26rem;
                    color: #ea0e23;
                    text-align: left;
                    font-weight: 600;

                    }
                    h4{
                        text-align: center;
                        line-height: .6rem;
                    }

                }

            }
        }
        .lcTime{
            width: 5.9rem;
            border-bottom: 2px solid #0250a4;
            position: absolute;
            bottom: 1.3rem;
            right: 0;
            li{

                float: left;
                height: .1rem;
                width: .3rem;
                border-left: 2px solid #0250a4;

            }
            li:nth-child(1){
                border-left: 0;
                 width: .1rem;
                height: .1rem;
                background-color: #0250a4;
                border-radius: 50%;
                margin:0 1.4rem -.05rem -0.02rem;
            }
            li:nth-child(2){
                border-left: 0;
                 width: .1rem;
                height: .1rem;
                background-color: #0250a4;
                border-radius: 50%;
                margin-right: .26rem;
            }
            li:nth-last-of-type(1){
                  border-left: 0;
                 width: .1rem;
                height: .1rem;
                background-color: #0250a4;
                border-radius: 50%;
                margin-right: .4rem;

            }
        }
        .lcNext{
            position: absolute;
            bottom: .2rem;
            width:2.5rem;
            height: .32rem;
            left: 50%;
            transform: translateX(-50%);
            img{
                display: inline-block;
                margin: 0 .5rem;
                width: .14rem;
                height: .26rem;
            }
        }
        .shuxian{
            width: .2rem;
            height: 1.4rem;
        //    text-align: center;
            display: block;
            position: absolute;
            bottom: 1.28rem;
            left: 50%;
            transform: translateX(-50%);
            
            .xian{
                height: 1.2rem;
                width: .04rem;
                 background-color: #df0f1d;
                 display: block;
                 margin: 0 auto;

            }
            .yuan{
                display: block;
                width: .2rem;
                height: .2rem;
                border-radius: 50%;
                background-color: #df0f1d;
                margin: 0 auto;
            }
        }
    }
    .fzgd{
        .fzgd_list{
            position: relative;
            margin-bottom: .1rem;
            img{
                display: block;
                width: 100%;
                height: 100%;
            }
            .listCont{
                position: absolute;
                top: 0;
                padding: .2rem .4rem;
                color: #f5fafd;
                h4{
                    width: 2.5rem;
                    height: .6rem;
                    line-height: .6rem;
                    margin: 0 auto;
                    text-align: center;
                    background-color: #df0f1d;
                    color: #fefefe;
                    font-size: .22rem;
                    margin-bottom: .1rem;
                }
                p{
                    text-indent: 2em;
                    line-height: .36rem;
                    font-size: .26rem;
                    padding: .05rem 0;
                }
            }
        }
    }

}

</style>



// WEBPACK FOOTER //
// src/pages/Group.vue